module.exports = __webpack_public_path__ + "img/CHS_210_thumb.802a48c4.jpg";